import Lock from '@mui/icons-material/Lock';
import LockOpen from '@mui/icons-material/LockOpen';
import { Box, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { blue, red } from '@mui/material/colors';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import NomeUtil from '@/util/NomeUtil';

class ExibirOcultarNome extends ReactComponent {
    mostraNome = false;

    mostrarNomeCompleto = () => {
        this.mostraNome = !this.mostraNome;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            mostraNome: observable,
            mostrarNomeCompleto: action,
            nomeAbreviado: computed,
            nome: computed,
            prefixoNome: computed,
            registroComplementar: computed,
            textoTitleTooltipNome: computed,
            titleTooltipNome: computed
        });
    }

    get nomeAbreviado() {
        return NomeUtil.abreviarNome(
            this.observableProps.nomeSocial ? this.observableProps.nomeSocial : this.observableProps.nome
        );
    }

    get nome() {
        return this.observableProps.nomeSocial ? this.observableProps.nomeSocial : this.observableProps.nome;
    }

    get prefixoNome() {
        return this.observableProps.prefixoNome ? `${this.observableProps.prefixoNome} ` : '';
    }

    get registroComplementar() {
        return this.observableProps.registroComplementar ? ` (${this.observableProps.registroComplementar})` : '';
    }

    get textoTitleTooltipNome() {
        return this.observableProps.nomeSocial
            ? this.observableProps.nomeSocial + ` (registrado(a) civilmente como ${this.observableProps.nome}) `
            : this.observableProps.nome;
    }

    get titleTooltipNome() {
        if (this.observableProps.abreviarNome && !this.mostraNome) {
            return null;
        }

        return <Typography>{this.textoTitleTooltipNome}</Typography>;
    }

    renderTooltipNome() {
        return (
            <Tooltip title={this.titleTooltipNome}>
                <Typography
                    component="span"
                    sx={{ ...this.observableProps.estiloTexto }}
                >
                    {`${this.prefixoNome}${this.observableProps.abreviarNome && !this.mostraNome ? this.nomeAbreviado : this.nome}${this.registroComplementar}`}
                </Typography>
            </Tooltip>
        );
    }

    render() {
        return (
            <Box component="span">
                {this.observableProps.abreviarNome &&
                    (!this.mostraNome ? (
                        <Tooltip
                            placement="top"
                            title={<Typography>Exibir nome completo</Typography>}
                        >
                            <Box
                                component="span"
                                sx={{ color: red[900], cursor: 'pointer', ...this.observableProps.estiloIcone }}
                            >
                                <Lock
                                    data-testid="exibirNome"
                                    style={{ height: '20px', verticalAlign: 'top' }}
                                    onClick={() => this.mostrarNomeCompleto()}
                                />
                            </Box>
                        </Tooltip>
                    ) : (
                        <Tooltip
                            placement="top"
                            title={<Typography>Ocultar nome completo</Typography>}
                        >
                            <Box
                                component="span"
                                data-sentry-mask
                                sx={{ color: blue[900], cursor: 'pointer', ...this.observableProps.estiloIcone }}
                            >
                                <LockOpen
                                    data-testid="ocultarNome"
                                    style={{ height: '20px', verticalAlign: 'top' }}
                                    onClick={() => this.mostrarNomeCompleto()}
                                />
                            </Box>
                        </Tooltip>
                    ))}
                {this.renderTooltipNome()}
            </Box>
        );
    }
}

export default inject('stores')(observer(ExibirOcultarNome));
